module.exports = __webpack_public_path__ + "img/CL_OUTGOING_GOODS_1.3358ebbd.png";